import { useSoftDeployAccess } from 'App/components/hooks';

export default () => {
	return useSoftDeployAccess('COMPANY_MAP');
};
